import React, { useMemo } from 'react';

import {
    Icon,
    IconName,
    IconSize,
    Popover,
    Text,
    TextLevels,
    TypographyAlign,
    TypographyBold,
    View,
} from '@bytel/trilogy-react';

import { MobilePlanType } from '@app-types/plan';

import { formatPrice } from '@helpers/wording';

type RefundPopoverProps = {
    offer: MobilePlanType;
    isRenewal?: boolean;
};

export function RefundPopover({ offer, isRenewal }: Readonly<RefundPopoverProps>) {
    const discountWording = useMemo(() => {
        if (offer.renewalDiscounts?.find((d) => (d?.dureeOffre || 0) > 0)) {
            return 'Promo web';
        }
        return 'Remises client';
    }, [offer.renewalDiscounts]);

    if (!isRenewal || !offer.hasRenewalDiscounts || (offer.renewalDiscounts?.length ?? 0) <= 0) {
        return null;
    }

    return (
        <Text
            marginless
            typo={[TypographyAlign.TEXT_CENTERED, TypographyBold.TEXT_WEIGHT_SEMIBOLD]}
            level={TextLevels.ONE}
        >
            {discountWording}
            <Popover trigger={<Icon name={IconName.INFOS_CIRCLE} size={IconSize.SMALL} />}>
                <Text>
                    {offer.renewalDiscounts?.map((discount) => (
                        <View key={discount.idOffre}>
                            {discount.libelleCommercial}{' '}
                            {discount.tarifRecurrent?.tarifTTC && Math.abs(discount.tarifRecurrent.tarifTTC) >= 0 ? (
                                <Text>{formatPrice(discount.tarifRecurrent.tarifTTC)}</Text>
                            ) : null}
                        </View>
                    ))}
                </Text>
            </Popover>
        </Text>
    );
}
